import {
    RECEIVE_DATA,
    REQUEST_DATA,
} from './EducationChartActions';
import chartSettings from './EducationChartSettings';

export const CHART_DATA = {
    Categories: [],
    Series: {
        Expenses: [],
        Covered: [],
    },
    title: '',
};

export const CLIENT_STATE = {
    chartSettings,
    currentGoalId: '',
    data: CHART_DATA,
    fpId: '',
    goalId: '',
    isPdf: false,
    isPrint: false,
    loaded: false,
};

const INITIAL_STATE = {};

const healthCareChartReducer = (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case REQUEST_DATA: {
            return {
                ...state,
                [action.clientId]: {
                    ...CLIENT_STATE,
                    ...state[action.clientId],
                    loaded: false,
                    data: CHART_DATA,
                },
            };
        }

        case RECEIVE_DATA: {
            return {
                ...state,
                [action.clientId]: {
                    ...CLIENT_STATE,
                    ...state[action.clientId],
                    goalId: action.goalId,
                    currentGoalId: action.goalId,
                    loaded: true,
                    data: action.data,
                },
            };
        }

        default:
            return state;
    }
};

export default healthCareChartReducer;
